import { Navigate } from "react-router-dom";

function AutoLangRedirect() {
  const browserLang = navigator.language.startsWith("fr") ? "fr" : "en";
  return <Navigate to={`/${browserLang}`} replace />;
}

export default AutoLangRedirect;